import React from "react";
import { FiMail, FiPhone } from "react-icons/fi";
import "./HiringManagerCard.css";
import { Deleteicon } from "../../../Icons/Deleteicon";

const HiringManagerCard = ({ manager, onClick }) => {
  const { firstName, lastName, fullName, emailId, contactNumber, jobTitle } =
    manager;

  const getInitials = () => {
    if (fullName) {
      return fullName.substring(0, 2).toUpperCase();
    } else {
      const f = firstName ? firstName.charAt(0).toUpperCase() : "";
      const l = lastName ? lastName.charAt(0).toUpperCase() : "";
      return `${f}${l}`;
    }
  };

  return (
    <div
      className="hiring-manager-card"
      onClick={() => onClick("detailspage", manager)}
    >
      <div className="card-top">
        <div className="initials-circle">{getInitials()}</div>
        <div className="manager-name-section">
          {fullName ? (
            <h3 className="hiring-manager-name">{fullName}</h3>
          ) : (
            <h3 className="hiring-manager-name">
              {firstName} {lastName}
            </h3>
          )}
          <p className="manager-designation">{jobTitle || ""}</p>
        </div>
        <div className="client-delete-icon">
          <Deleteicon
            width="18px"
            height="18px"
            onClick={(e) => {
              e.stopPropagation();
              onClick("confirmDel", manager);
            }}
          />
        </div>
      </div>
      <div className="manager-details">
        <div className="manager-detail-item">
          <img
            src={process.env.PUBLIC_URL + "/assests/img/MailIcon.svg"}
            alt=""
            className="detail-icon"
          />
          <span>{emailId}</span>
        </div>
        <div className="manager-detail-item">
          <img
            src={process.env.PUBLIC_URL + "/assests/img/CallIcon.svg"}
            alt=""
            className="detail-icon"
          />
          <span>{contactNumber}</span>
        </div>
      </div>
    </div>
  );
};

export default HiringManagerCard;
